import React from "react";

export function LetterTile({
  letter, points, selected, onClick, testId, size = "md", faded = false, dragProps = {},
}) {
  const sizes = {
    xs: "w-8 h-8 text-sm",
    sm: "w-10 h-10 text-lg",
    md: "w-12 h-12 text-xl",
    lg: "w-14 h-14 text-2xl",
  };
  const displayLetter = letter === "?" ? " " : letter;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      disabled={!onClick}
      className={`tile ${sizes[size]} ${selected ? "selected" : ""} ${
        faded ? "opacity-40" : ""
      } inline-flex items-center justify-center relative`}
      {...dragProps}
    >
      <span>{displayLetter?.toUpperCase()}</span>
      {points != null && (
        <span className="absolute bottom-0.5 right-1 text-[9px] font-medium opacity-70">
          {points}
        </span>
      )}
    </button>
  );
}
